import { z } from "zod";

/**
 * `?asOf=<iso>` on a catalog detail route: render the definition as it stood at
 * that instant.
 *
 * An INSTANT, not a version. Catalog references are unpinned, so a child can be
 * revised underneath a parent that was never re-authored — "version 3" names a
 * revision of one definition, never a state of the graph around it. The version
 * the page shows is an OUTPUT of resolution, which is why it is read off the
 * resolved definition rather than off the url.
 */
// Hand-rolled rather than `z.iso.datetime()` or `.string().datetime()`: the app
// declares zod 4 but Vite resolves the zod 3 copy `@repo/api` pulls in, so the
// v4-only `z.iso` namespace type-checks and is undefined at runtime. This
// spelling works on either.
export const asOfSearchSchema = z.object({
  asOf: z
    .string()
    .refine((value) => !Number.isNaN(Date.parse(value)), { message: "asOf must be an ISO instant" })
    .optional(),
});

export type AsOfSearch = z.infer<typeof asOfSearchSchema>;
